import 'redInfoService'

import redInfoModule from './redInfoModule'

import redInfoCtrl from './redInfoCtrl'
import modalRedFindInvCtrl from './modalRedFindInvCtrl'
import downLoadPageCtrl from './downLoadPageCtrl'
import modalRedInfoBalanceCtrl from './modalRedInfoBalanceCtrl'
import modalPrintCtrl from './modalPrintCtrl'
import inserInfoNoCtrl from './inserInfoNoCtrl'
import { redWordInfo } from 'redevConfig'

import redInfoChangeUkeyModalCtrl from './redInfoChangeUkeyModalCtrl' // 选择开票点

const list = (redWordInfo && redWordInfo.list) || ''
const add = (redWordInfo && redWordInfo.add) || ''
const edit = (redWordInfo && redWordInfo.edit) || ''
const detail = (redWordInfo && redWordInfo.detail) || ''
const redInfoListCtrl = list ? require(`redevelopment/outputManage/redWordInfo/${list.controllerName}`) : require('./redInfoListCtrl')
const addRedInfoCtrl = add ? require(`redevelopment/outputManage/redWordInfo/${add.controllerName}`) : require('./addRedInfoCtrl')
const editRedInfoCtrl = edit ? require(`redevelopment/outputManage/redWordInfo/${edit.controllerName}`) : require('./editRedInfoCtrl')
const redInfoDetailCtrl = detail ? require(`redevelopment/outputManage/redWordInfo/${detail.controllerName}`) : require('./redInfoDetailCtrl')

// 對應一下ruouters
import {
    Router,
    redInfoListRouter,
    addRouter,
    editRouter,
    detailRouter,
    RedInfoBillDetailCtrlRouter,
    redInvoiceRouter,
} from './Routers'

function config($stateProvider) {
    $stateProvider.state(Router.state, Router.config)
        .state(redInfoListRouter.state, redInfoListRouter.config)
        .state(addRouter.state, addRouter.config)
        .state(detailRouter.state, detailRouter.config)
        .state(RedInfoBillDetailCtrlRouter.state, RedInfoBillDetailCtrlRouter.config)
        .state(editRouter.state, editRouter.config)
        .state(redInvoiceRouter.state, redInvoiceRouter.config)
}

export default redInfoModule
    .config(['$stateProvider', config])
    .controller('redInfoListCtrl', redInfoListCtrl.default)
    .controller('redInfoCtrl', redInfoCtrl)
    .controller('addRedInfoCtrl', addRedInfoCtrl.default)
    .controller('editRedInfoCtrl', editRedInfoCtrl.default)
    .controller('redInfoDetailCtrl', redInfoDetailCtrl.default)
    .controller('modalRedFindInvCtrl', modalRedFindInvCtrl)
    .controller('downLoadPageCtrl', downLoadPageCtrl)
    .controller('modalRedInfoBalanceCtrl', modalRedInfoBalanceCtrl)
    .controller('modalPrintCtrl', modalPrintCtrl)
    .controller('inserInfoNoCtrl', inserInfoNoCtrl)
    .controller('redInfoChangeUkeyModalCtrl', ['$scope', '$uibModalInstance', 'httpRequest', 'logger', 'Upload', '$timeout', '$rootScope', '$uibModal', redInfoChangeUkeyModalCtrl])
    .name


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/index.js